<form
  class="register-form"
  [formGroup]="registerForm"
  (ngSubmit)="onSubmit()"
  (change)="saveOnChange()"
>
  <div class="register-fieldBox">
    <p>氏名<app-required-mark></app-required-mark></p>
    <div class="register-names">
      <label class="register-label">
        <div class="register-input-wrapper">
          <span [ngClass]="{ hasValue: registerForm.get('familyName')?.value }"
            >姓</span
          >
          <input
            class="register-input"
            type="text"
            formControlName="familyName"
          />
        </div>
        <span class="register-input-error">{{
          getErrorMessage("familyName")
        }}</span>
      </label>
      <label class="register-label">
        <div class="register-input-wrapper">
          <span [ngClass]="{ hasValue: registerForm.get('givenName')?.value }"
            >名</span
          >
          <input
            class="register-input"
            type="text"
            formControlName="givenName"
          />
        </div>
        <span class="register-input-error">{{
          getErrorMessage("givenName")
        }}</span>
      </label>
    </div>
  </div>

  <div class="register-fieldBox">
    <p>メールアドレス<app-required-mark></app-required-mark></p>
    <label class="register-label">
      <div class="register-input-wrapper">
        <span [ngClass]="{ hasValue: registerForm.get('email')?.value }"
          >メールアドレス</span
        >
        <input class="register-input" type="email" formControlName="email" />
      </div>
      <span class="register-input-error">{{ getErrorMessage("email") }}</span>
    </label>
    <details class="">
      <summary class="register-emailNotice">
        docomo、SoftBank、auのメールをご利用の方へ
      </summary>
      <div class="register-emailDetails">
        <p>
          携帯メール(docomo、SoftBank、au)の場合、仮登録メールが届かない（または迷惑メールに振り分けられる）ことがあります。
        </p>
        <p>
          事前に「dx-utility.com」からのメール受信許可設定を行ってください。
        </p>
      </div>
    </details>
  </div>

  <div class="register-fieldBox" formGroupName="password">
    <p>パスワード<app-required-mark></app-required-mark></p>
    <label class="register-label">
      <div class="register-input-wrapper">
        <span
          [ngClass]="{
            hasValue: registerForm.get('password.rawPassword')?.value
          }"
          >パスワード</span
        >
        <input
          class="register-input"
          [type]="passwordToggle.password ? 'text' : 'password'"
          formControlName="rawPassword"
        />
        <app-mdi-eye
          class="register-input-eye"
          [show]="passwordToggle.password"
          (click)="passwordToggle.password = !passwordToggle.password"
        ></app-mdi-eye>
      </div>
      <span class="register-input-error">{{
        getErrorMessage(
          "password.rawPassword",
          " 半角の英字と数字を必ず含む8文字以上で入力してください。記号の使用も可能です。"
        )
      }}</span>
    </label>
  </div>

  <div class="register-fieldBox" formGroupName="password">
    <p>パスワード（確認）<app-required-mark></app-required-mark></p>
    <label class="register-label">
      <div class="register-input-wrapper">
        <span
          [ngClass]="{
            hasValue: registerForm.get('password.confirmPassword')?.value
          }"
          >パスワード（確認）</span
        >
        <input
          class="register-input"
          [type]="passwordToggle.confirm ? 'text' : 'password'"
          formControlName="confirmPassword"
        />
        <app-mdi-eye
          class="register-input-eye"
          [show]="passwordToggle.confirm"
          (click)="passwordToggle.confirm = !passwordToggle.confirm"
        ></app-mdi-eye>
      </div>
      <span class="register-input-error">{{
        getErrorMessage(
          "password.confirmPassword",
          "パスワードを確認するために再入力してください。"
        )
      }}</span>
    </label>
  </div>

  <div class="register-fieldBox" formGroupName="birthDate">
    <div>
      <p>生年月日<app-required-mark></app-required-mark></p>
      <div class="register-birthDate">
        <label
          class="register-select year"
          [ngClass]="{
            'ng-invalid': registerForm.get('birthDate.year')?.invalid,
            'ng-touched': registerForm.get('birthDate.year')?.touched
          }"
          (focusout)="validateManually('birthDate.year')"
        >
          <app-pulldown
            style="height: 56px"
            class="v-input theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder"
            [items]="years"
            (selectedChange)="updateBirthYear($event)"
            [selected]="registerForm.get('birthDate.year')?.value"
            placeholder="年"
          >
          </app-pulldown>
        </label>
        <label
          class="register-select month"
          [ngClass]="{
            'ng-invalid': registerForm.get('birthDate.month')?.invalid,
            'ng-touched': registerForm.get('birthDate.month')?.touched
          }"
          (focusout)="validateManually('birthDate.month')"
        >
          <app-pulldown
            style="height: 56px"
            class="v-input theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder"
            [items]="months"
            (selectedChange)="updateBirthMonth($event)"
            [selected]="registerForm.get('birthDate.month')?.value"
            placeholder="月"
          >
          </app-pulldown>
        </label>
        <label
          class="register-select date"
          [ngClass]="{
            'ng-invalid': registerForm.get('birthDate.date')?.invalid,
            'ng-touched': registerForm.get('birthDate.date')?.touched
          }"
          (focusout)="validateManually('birthDate.date')"
        >
          <app-pulldown
            style="height: 56px"
            class="v-input theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder"
            [items]="dates"
            (selectedChange)="updateBirthDate($event)"
            [selected]="registerForm.get('birthDate.date')?.value"
            placeholder="日"
          >
          </app-pulldown>
        </label>
      </div>
      <span class="register-input-error">{{
        getErrorMessage("birthDate")
      }}</span>
    </div>
  </div>

  <div class="register-fieldBox">
    <p>性別<app-required-mark></app-required-mark></p>
    <label
      class="register-select"
      [ngClass]="{
        'ng-invalid': registerForm.get('gender')?.invalid,
        'ng-touched': registerForm.get('gender')?.touched
      }"
      (focusout)="validateManually('gender')"
    >
      <app-pulldown
        style="height: 56px; display: block"
        class="v-inputtheme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder"
        [items]="genders"
        (selectedChange)="updateGender($event)"
        [selected]="registerForm.get('gender')?.value"
        placeholder="性別を選択"
      >
      </app-pulldown>
      <span class="register-input-error">{{ getErrorMessage("gender") }}</span>
    </label>
  </div>

  <div class="register-fieldBox">
    <p>郵便番号<app-required-mark></app-required-mark></p>
    <label class="register-label">
      <div class="register-input-wrapper">
        <span [ngClass]="{ hasValue: registerForm.get('zipcode')?.value }"
          >郵便番号</span
        >
        <input
          class="register-input"
          type="text"
          formControlName="zipcode"
          maxlength="7"
        />
      </div>
      <span class="register-example">例： 1234567</span>
      <span class="register-input-error">{{ getErrorMessage("zipcode") }}</span>
    </label>
  </div>

  <div class="register-fieldBox" formGroupName="address">
    <p>住所</p>
    <div class="register-address">
      <label class="register-label">
        <app-pulldown
          style="height: 56px"
          class="v-input theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined v-text-field--placeholder"
          [items]="prefectures"
          (selectedChange)="updatePrefecture($event)"
          [selected]="registerForm.get('address.prefecture')?.value"
        ></app-pulldown>
        <span class="register-example"> </span>
      </label>
      <label class="register-label">
        <div class="register-input-wrapper">
          <span
            [ngClass]="{ hasValue: registerForm.get('address.city')?.value }"
            >市区町村</span
          >
          <input class="register-input" type="text" formControlName="city" />
        </div>
        <span class="register-example">例： 〇〇市</span>
      </label>
      <label class="register-label">
        <div class="register-input-wrapper">
          <span
            [ngClass]="{ hasValue: registerForm.get('address.town')?.value }"
            >町名・番地</span
          >
          <input class="register-input" type="text" formControlName="town" />
        </div>
        <span class="register-example">例： 〇〇町 1-2-3</span>
      </label>
      <label class="register-label">
        <div class="register-input-wrapper">
          <span
            [ngClass]="{
              hasValue: registerForm.get('address.building')?.value
            }"
            >建物名・部屋番号</span
          >
          <input
            class="register-input"
            type="text"
            formControlName="building"
          />
        </div>
        <span class="register-example">例： 〇〇マンション 123</span>
      </label>
    </div>
  </div>

  <div class="register-term">
    <label class="">
      <i
        aria-hidden="true"
        class="text-black-38 v-icon notranslate mdi"
        [ngClass]="{
          'mdi-checkbox-marked theme--light primary--text':
            registerForm.get('acceptTerm')?.value,
          'mdi-checkbox-blank-outline theme--light':
            !registerForm.get('acceptTerm')?.value
        }"
      ></i>
      <input
        class="register-input"
        type="checkbox"
        formControlName="acceptTerm"
      />
    </label>
    <span
      ><a [href]="termsUrl" target="_blank" class="text-link primary--text"
        >利用規約およびプライバシーポリシー</a
      >に同意します。</span
    >
  </div>

  <p *ngIf="registerForm.invalid">
    入力内容に不足や誤りがあります。ご確認ください。
  </p>

  <!-- 送信後にサーバーから送られたエラーはフォーム自体のエラーとは区別する。登録ボタンの動作にも影響させない。 -->
  <p *ngIf="listErrorsFromResponse().length">以下の項目をご確認ください。</p>
  <ul class="register-errorList">
    <li *ngFor="let error of listErrorsFromResponse()">
      {{ error }}
    </li>
  </ul>

  <button
    class="register-button"
    type="submit"
    [disabled]="registerForm.invalid"
  >
    登録
  </button>
</form>
